var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-chip',{class:['status-chip', _vm.type]},[_c('span',{staticClass:"status-text"},[_vm._v("\n    "+_vm._s(_vm.status.label)+"\n  ")]),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("\n    "+_vm._s(_vm.status.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }